
import { Dialog, Toast, SwipeCell, ActionSheet } from "vant";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { buyOrder, mycommodity, orderDel } from "@/req/order";
import payModal from "./pay/index.vue";
Vue.use(SwipeCell);
Vue.use(ActionSheet);
@Component({
  components: { payModal },
})
export default class Logout extends Vue {
  public isLoading = false;
  public time: any = "";
  public page = 1;
  public size = 10;
  public list: any = [];
  public rows: any = {};
  public mounted() {
    if (this.$store.state.order.active == 3) {
      this.getmyOrder();
    } else {
      this.getbuyOrder();
    }
  }
  // 监听nav切换
  @Watch("$store.state.order.active")
  public change() {
    // console.log(this.active);
    if (this.$store.state.order.active == 1) {
      this.$store.state.order.type = "purchaser";
      this.list = [];
      this.getbuyOrder();
      return false;
    }
    if (this.$store.state.order.active == 2) {
      this.$store.state.order.type = "seller";
      this.list = [];
      this.getbuyOrder();
      return false;
    }
    if (this.$store.state.order.active == 3) {
      this.$store.state.order.type = "";
      this.list = [];
      this.getmyOrder();
    }
  }
  // 获取我买的我卖的订单列表
  public async getbuyOrder() {
    const res = await buyOrder({
      identity: this.$store.state.order.type,
      status: "",
      page: this.page,
      size: this.size,
    });
    if (res.code == 200) {
      this.list = res.data;
      // 1800000 = 30min
      // this.list.data = [...this.list.data, ...res.data.data]
      setTimeout(() => {
        //   Toast("刷新成功");
        this.isLoading = false;
      }, 1000);
    }
  }
  // 获取指定我订单列表
  public async getmyOrder() {
    const res = await mycommodity({
      page: this.page,
      size: this.size,
    });
    // if (res.code == 200) {
    //   console.log(res.data)
    // }
  }
  // 下拉刷新
  public onRefresh() {
    this.page = 1;
    this.getbuyOrder();
  }
  // 滑动点击操作
  public delbtn(item) {
    Dialog.confirm({
      message: "确认删除订单",
    })
      .then((res) => {
        this.delOrder(item.id);
      })
      .catch(() => {
        close();
      });
  }
  public async delOrder(ids) {
    const res = await orderDel({
      order_id: ids,
    });
    if (res.code == 200) {
      this.getbuyOrder();
      Toast(res.msg);
    }
  }
  // 点金前往订单详情
  public getDetail(item) {
    this.$router.push({
      path: "/orderDetail",
      query: { id: item.id, type: this.$store.state.order.active },
    });
  }
  // 点击付款弹框
  public goPay(item) {
    const $payModal: any = this.$refs.payModal;
    $payModal.show(item, true);
  }
}
